module.exports = __webpack_public_path__ + "static/media/join-in-img1-6.e6db8cfb.jpg";